import Button from "@marginly/ui/components/button";
import T from "@marginly/ui/components/typography";
import copy from "copy-to-clipboard";
import { useCallback } from "react";
import { t } from "ttag";
import { useAccount, useDisconnect } from "wagmi";

import Space from "@/components/common/space";
import { useRx } from "@/contexts/rx";

import { NetworkModalTop } from "../wallet-modal/styled";

interface Props {
  onConnectClick: () => void;
}

export default function ModalCommon({ onConnectClick }: Props) {
  const account = useAccount();
  const { notification$ } = useRx();
  const { disconnect } = useDisconnect();

  const handleCopy = useCallback(() => {
    copy(account.address || "");

    notification$.next({
      message: `Address copied.`,
      imgSrc: "/images/copy.svg",
    });
  }, [account.address, notification$]);

  return (
    <>
      {account.isConnected ? (
        <NetworkModalTop>
          <T headerM>
            {account.address?.slice(0, 4) + ".." + account.address?.slice(-4)}
          </T>
          <Button sm secondary onClick={() => handleCopy()}>
            <T action>{t`Copy`}</T>
          </Button>
        </NetworkModalTop>
      ) : (
        <NetworkModalTop>
          <T headerM style={{ color: "var(--text-tertiary)" }}>
            Well...
          </T>

          <Button
            sm
            onClick={() => {
              onConnectClick();
            }}
          >
            {t`Connect Wallet`}
          </Button>
        </NetworkModalTop>
      )}

      <Space height={24} heightMobile={24} />

      {account.isConnected ? (
        <>
          <Space height={24} heightMobile={24} />
          <Button
            tertiary
            md
            style={{ width: "100%" }}
            onClick={() => disconnect()}
          >
            <T action>Log Out</T>
          </Button>
        </>
      ) : (
        <></>
      )}
    </>
  );
}
